export const accountWorkflowGuide =
  'How accounts work: (1) the accounts list is driven with account_list_set_filters / account_list_paginate — ' +
  'read rows from context.account_list.items (each has a pjas://account:<id> link); ' +
  '(2) open_link opens the account form; (3) current_account_form_set_fields edits in memory — ' +
  'when creating, password is required (write-only, not shown in context); ' +
  '(4) current_account_form_save persists. goto_create_account opens an empty form (creates nothing until save). ' +
  'To change an existing account password from the list, set_account_password is sensitive.';
